import { FC } from 'react';

import { AdElementText, AdTemplate } from '@adflow/types';
import { Flex, FormControl, FormLabel } from '@chakra-ui/react';

import DayFormatControls, { isDayPresent } from './DayFormatControls';
import TimeFormatControls, { isTimePresent } from './TimeFormatControls';
import MonthFormatControls, { isMonthPresent } from './MonthFormatControls';
import CountdownFormatControls, { isCountdownPresent } from './CountdownControls';
import DateFormatControls, { isDatePresent, isTextDatePresent } from './DateFormatControls';

type Props = {
  selectedElement: AdElementText;
  importSourceType?: AdTemplate['importSourceType'];
};

export const isDateTimePresent = (textElement: AdElementText) => {
  return (
    isDayPresent(textElement) ||
    isTimePresent(textElement) ||
    isMonthPresent(textElement) ||
    isCountdownPresent(textElement) ||
    isDatePresent(textElement)
  );
};

const DateTimeControls: FC<Props> = ({ selectedElement, importSourceType }) => {
  return (
    <FormControl alignItems="center" mt={5} mb={2} mr={0}>
      <Flex direction="column">
        {(isTimePresent(selectedElement) || isTextDatePresent(selectedElement)) && (
          <TimeFormatControls textElement={selectedElement} />
        )}
        {(isMonthPresent(selectedElement) ||
          isDayPresent(selectedElement) ||
          isDatePresent(selectedElement)) && (
          <FormLabel htmlFor="date-format" mb={'1'} fontWeight={'semibold'}>
            Date Format
          </FormLabel>
        )}
        {isMonthPresent(selectedElement) && <MonthFormatControls textElement={selectedElement} />}
        {isDayPresent(selectedElement) && <DayFormatControls textElement={selectedElement} />}
        {isDatePresent(selectedElement) && <DateFormatControls textElement={selectedElement} />}
        {isCountdownPresent(selectedElement) && (
          <CountdownFormatControls
            textElement={selectedElement}
            importSourceType={importSourceType}
          />
        )}
      </Flex>
    </FormControl>
  );
};

DateTimeControls.displayName = 'DateTimeControls';

export default DateTimeControls;
